import React from 'react'
import { Container, Row } from 'react-bootstrap'
import {Link} from 'react-router-dom'
import CardProduk from 'components/dashboard/dashcomp/card_produk'

export default function brand_page() {
    return (
        <Container className="containe-brand-page">
            <div className="profile">
                <img src="asset/brand/cordova0.png" alt="cordova" />
                <div className="cordova">
                    <h3>Cordova</h3>
                    <div className="cordova-brand">
                        <div className="cordova-lokasi">
                            <p>Makassar</p>
                            <p>Buku, Kurma</p>
                            <button type="button"><Link to="#"></Link>Chat Penjual</button>
                        </div>
                        <div className="kualitas-product">
                            <h6>Kualitas Produk</h6>
                            <h3>5.0</h3>
                            <h6>Jumlah Ulasan</h6>
                            <small>4590 ulasan</small>
                        </div>
                        <div className="product-terjual">
                            <h6>Produk Terjual</h6>
                            <h3>4392 <small>Barang</small></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gambar">
                <img src="asset/brand/bener.png" alt="bener" />
            </div>
            <div className="content">
             <h3>Produk Terbaru</h3>
            <Row>
                {
                    ProdukTerbaru.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`${item.src + i}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere="Bagikan Produk"
                            />
                        )
                    })
                }
            </Row>
            <h3>Produk Terpopuler</h3>
            <Row>
                {
                    ProdukTerbaru.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`${item.src + i}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere="Bagikan Produk"
                            />
                        )
                    })
                }
            </Row>
            <h3>Semua Produk</h3>
            <Row>
                {
                    ProdukTerbaru.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`${item.src + i}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere="Bagikan Produk"
                            />
                        )
                    })
                }
            </Row>
            </div>
        </Container>
    )
}

const ProdukTerbaru = [
    {src:"asset/brand/img", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000"},{src:"asset/brand/img", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},{src:"asset/brand/img", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000"},{src:"asset/brand/img", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000"},{src:"asset/brand/img", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},{src:"asset/brand/img", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000"}
]
